import React from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import MLFoundations from './pages/courses/MLFoundations'
import Dashboard from './pages/Dashboard'
import About from './pages/About'
import Contact from './pages/Contact' 
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import English from './pages/English'
import Statistics from './pages/courses/Statistics'
// import Programming from './pages/Programming'
import Grammar from './pages/Grammar'
import Vocabulary from './pages/Vocabulary'
import ReadingComprehension from './pages/ReadingComprehension'
import Writing from './pages/Writing'
import DiagnosticTest from './pages/DiagnosticTest'
import Assessment from './pages/Assessment'
import AdminDashboard from './pages/AdminDashboard'
import SubjectAnalysis from './pages/SubjectAnalysis'
import MathDashboard from './pages/MathDashboard'
import MathExamAnalysis from './pages/MathExamAnalysis'
import Math2Dashboard from './pages/Math2Dashboard'
import Stats1Dashboard from './pages/Stats1Dashboard'
import Stats2Dashboard from './pages/Stats2Dashboard'
import CTDashboard from './pages/CTDashboard'
import PythonDashboard from './pages/PythonDashboard'

import Algebra from './pages/Algebra'
import IIITMMath from './pages/courses/IIITM-math'
import AlgebraSubject from './pages/courses/algebra'
import Arithmetic from './pages/courses/arithmetic'
import MathSubject from './pages/courses/Math'
import PDSA from './pages/courses/PDSA'
import Math2 from './pages/courses/Math2'
import StatisticsSubject from './pages/courses/Statistics'
import Statistics2 from './pages/courses/Statistics2'
//import Python from './pages/courses/Python'
import AdminSubject from './pages/courses/Admin'
import IITMMathQuiz from './pages/courses/IITMMathQuiz'
import StatisticsQuiz from './pages/courses/StatisticsQuiz'
import MathReview from './pages/MathReview'
import Math2Quiz from './pages/courses/Math2Quiz'
import MathExamReview from './pages/MathReview'

import DBMS from './pages/courses/DBMS'
import DBMSQuiz from './pages/courses/DBMSQuiz'


// PDSA quiz type imports
import PdsaTestQuiz from './pages/courses/PDSA/PdsaTestQuiz'
import PdsaCodingQuiz from './pages/courses/PDSA/PdsaCodingQuiz'
import PdsaInterviewQuiz from './pages/courses/PDSA/PdsaInterviewQuiz'

// Statistics - II
import Stats2Quiz from './pages/courses/Stats2Quiz'
import Stats2Review from './pages/courses/Stats2Review'

// competitive course
import CompetitiveExamFoundation from './pages/courses/CompetitiveExamFoundation';
import MathQuiz from './pages/courses/Competitive/MathQuiz'
import ReviewPage from './pages/courses/Competitive/MathReview'
import CompetitiveMath from './pages/courses/Competitive/CompetitiveMath'
import PhysicsQuiz from './pages/courses/Competitive/PhysicsQuiz'

// import JAVA from './pages/courses/JAVA'
import JavaQuiz from './pages/courses/JAVA/JavaQuiz'

import JEE from './pages/courses/JEE'
import JEEQuiz from './pages/courses/JEEQuiz'
import JEEAdvancedDashboard from './pages/JEEAdminPage'
import JEEAdvancedAnalysis from './pages/JEEAdvancedAnalysis'
import QuestionGeneratorPage from './pages/QuestionGeneratorPage'

import JEEMain from './pages/courses/JEEMain'
import JEEMainQuiz from './pages/courses/JEEMainQuiz'
import JEEMainTest from './pages/courses/JEEMainTest'
import JEEMainAnalysis from './pages/JEEMainAnalysis'
import JEEMainDashboard from './pages/JEEMainDashboard'

import SAT from './pages/courses/SAT'
import SATMain from './pages/courses/SATMain'
import SATQuiz from './pages/courses/SATQuiz'
import SATFullTest from './pages/courses/SATFullTest'
import SATDashboard from './pages/SATDashboard'
import SATAnalysis from './pages/SATAnalysis'
import SATExamAnalysis from './pages/SATExamAnalysis'
import SATScoreDashboard from './pages/courses/SATScoreDashboard'

// New Programming course
import PDSADashboard from './pages/PDSADashboard'
import ProgrammingCourses from './pages/courses/Programming'
import ProgrammingDashboard from './pages/ProgrammingDashboard'
import DataScienceDashboard from './pages/DataScienceDashboard'
import CoursePage from './pages/courses/Programming_Courses/CoursePage'
import QuizPage from './pages/courses/Programming_Courses/QuizPage'
import CodingPage from './pages/courses/Programming_Courses/CodingPage'
import ExamPage from './pages/courses/Programming_Courses/ExamPage'

//GMAT
import GMAT from './pages/courses/GMAT'
import GMATMain from './pages/courses/GMATMain'
import GMATQuiz from './pages/courses/GMATQuiz'
import GMATFullTest from './pages/courses/GMATFullTest'
import GMATDashboard from './pages/GMATDashboard'
import GMATExamAnalysis from './pages/GMATExamAnalysis'
import GMATAnalysis from './pages/GMATAnalysis'
import GMATScoreDashboard from './pages/courses/GMATScoreDashboard'

//ACT
import ACT from './pages/courses/ACT'
import ACTMain from './pages/courses/ACTMain'
import ACTQuiz from './pages/courses/ACTQuiz'
import ACTFullTest from './pages/courses/ACTFullTest'
import ACTDashboard from './pages/ACTDashboard'
import ACTExamAnalysis from './pages/ACTExamAnalysis'
import ACTAnalysis from './pages/ACTAnalysis'
import ACTScoreDashboard from './pages/courses/ACTScoreDashboard'

//gate da

import GATEDA from './pages/courses/GATEDA'
import GATEDAMain from './pages/courses/GATEDAMain'
import GATEDAQuiz from './pages/courses/GATEDAQuiz'
import GATEDAFullTest from './pages/courses/GATEDAFullTest'
import GATEDADashboard from './pages/GATEDADashboard'
import GATEDAExamAnalysis from './pages/GATEDAExamAnalysis'
import GATEDAAnalysis from './pages/GATEDAAnalysis'
import GATEDAScoreDashboard from './pages/courses/GATEDAScoreDashboard'

//cat
import CAT from './pages/courses/CAT'
import CATMain from './pages/courses/CATMain'
import CATQuiz from './pages/courses/CATQuiz'
import CATFullTest from './pages/courses/CATFullTest'
import CATDashboard from './pages/CATDashboard'
import CATExamAnalysis from './pages/CATExamAnalysis'
import CATAnalysis from './pages/CATAnalysis'
import CATScoreDashboard from './pages/courses/CATScoreDashboard'

       
//gre 
import GRE from './pages/courses/GRE'
import GREMain from './pages/courses/GREMain'
import GREQuiz from './pages/courses/GREQuiz'
import GREFullTest from './pages/courses/GREFullTest'
import GREDashboard from './pages/GREDashboard'
import GREExamAnalysis from './pages/GREExamAnalysis'
import GREAnalysis from './pages/GREAnalysis'
import GREScoreDashboard from './pages/courses/GREScoreDashboard'

// Software Testing — Layer 1 proctored diagnostic
import StDiagnostic, { ST_DIAGNOSTIC_PATH } from './pages/softwareTesting/StDiagnostic'
import StProctorView from './pages/softwareTesting/StProctorView'
import StAdmin from './pages/softwareTesting/StAdmin'
import StPractice from './pages/softwareTesting/StPractice'
import StPracticeProblem from './pages/softwareTesting/StPracticeProblem'



// The proctored diagnostic shows only the exam: no site header or footer that a
// candidate could click and leave by accident.
const EXAM_ONLY_PATHS = [ST_DIAGNOSTIC_PATH]

function SiteHeader() {
  return EXAM_ONLY_PATHS.includes(useLocation().pathname) ? null : <Header />
}

function SiteFooter() {
  return EXAM_ONLY_PATHS.includes(useLocation().pathname) ? null : <Footer />
}

function App() {
  return (
    <Router>
      <div className="App">
        <SiteHeader />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/data-science/ml-foundations" element={<MLFoundations />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/math" element={<IIITMMath />} />
            <Route path="/english" element={<English />} />
            <Route path="/statistics" element={<Statistics />} />

            <Route path="/english/grammar" element={<Grammar />} />
            <Route path="/english/vocabulary" element={<Vocabulary />} />
            <Route path="/english/reading-comprehension" element={<ReadingComprehension />} />
            <Route path="/english/writing" element={<Writing />} />
            <Route path="/diagnostic-test" element={<DiagnosticTest />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/math" element={<MathDashboard />} />
            <Route path="/admin/analysis/:subject/:userId" element={<SubjectAnalysis />} />
            <Route path="/admin/math/exam/:email/:topic/:attemptNumber" element={<MathExamAnalysis />} />
            <Route path="/admin/iitm-math2" element={<Math2Dashboard />} />
            <Route path="/admin/stats1" element={<Stats1Dashboard />} />
            <Route path="/admin/stats2" element={<Stats2Dashboard />} />
            <Route path="/admin/iitm-ct" element={<CTDashboard />} />
            <Route path="/admin/python" element={<PythonDashboard />} />
            <Route path="/admin/dsa" element={<PDSADashboard />} />
            <Route path="/admin/jee-advanced" element={<JEEAdvancedDashboard />} />
            <Route path="/admin/question-generator" element={<QuestionGeneratorPage />} />
            <Route path="/algebra" element={<Algebra />} />
            <Route path="/math2" element={<Math2 />} />
            <Route path="/statistics2" element={<Statistics2 />} />
            <Route path="/computational-thinking" element={<IIITMMath />} />
            <Route path="/dbms" element={<AdminSubject />} />

            {/* Course-specific routes */}
            <Route path="/courses/IIITM-math" element={<IIITMMath />} />
            <Route path="/courses/algebra" element={<AlgebraSubject />} />
            <Route path="/courses/arithmetic" element={<Arithmetic />} />
            <Route path="/courses/math" element={<MathSubject />} />
            <Route path="/courses/pdsa" element={<PDSA />} />
            <Route path="/courses/math2" element={<Math2 />} />
            <Route path="/courses/statistics" element={<StatisticsSubject />} />
            <Route path="/courses/statistics2" element={<Statistics2 />} />
            <Route path="/courses/admin" element={<AdminSubject />} />

            {/* IIITM Math Quiz — dynamic, DB-driven */}
            <Route path="/courses/IIITM-math/quiz/:topic" element={<IITMMathQuiz />} />
            <Route path="/admin/math/exam/:email/:topic/:attemptNumber" element={<MathReview />} />
            <Route path="/courses/IIITM-math/review" element={<MathReview />} />
            {/* Statistics Quiz — dynamic, DB-driven */}
            <Route path="/courses/statistics/quiz/:topic" element={<StatisticsQuiz />} />

            {/* PDSA quiz routes – parameterized */}
            <Route path="/courses/pdsa/test/:weekId" element={<PdsaTestQuiz />} />
            <Route path="/courses/pdsa/coding/:weekId" element={<PdsaCodingQuiz />} />
            <Route path="/courses/pdsa/interview/:weekId" element={<PdsaInterviewQuiz />} />

            {/* Math 2 Quiz — week-based, DB-driven */}
            <Route path="/courses/math2/quiz/:week" element={<Math2Quiz />} />

            {/* Statistics 2 Quiz — week-based, DB-driven */}
            <Route path="/courses/statistics2/quiz/:week" element={<Stats2Quiz />} />
            <Route path="/courses/statistics2/review" element={<Stats2Review />} />

            {/* competitive-exam-foundation */}
            <Route path="/competitive-exam-foundation" element={<CompetitiveExamFoundation />} />
            <Route path="/courses/competitive-math" element={<CompetitiveMath />} />
            <Route path="/courses/competitive-math/quiz/:week" element={<MathQuiz />} />
            <Route path="/courses/competitive-math/review" element={<ReviewPage />} />
            <Route path="/competitive-exam-foundation/physics" element={<PhysicsQuiz />} />

            {/*
            <Route path="/courses/python" element={<Python />} />
            <Route path="/programming" element={<Programming />} />
            <Route path="/courses/JAVA" element={<JAVA />} />
            */}

            <Route path="/courses/JAVA/:weekId" element={<JavaQuiz />} />

            {/* JEE Advanced — subject-wise quizzes + analysis */}
            <Route path="/courses/jee" element={<JEE />} />
            <Route path="/courses/jee/quiz/:subject" element={<JEEQuiz />} />
            <Route path="/courses/jee/analysis" element={<JEEAdvancedAnalysis />} />

            {/* JEE Main — paper listing, full test, analysis + legacy subject quizzes */}
            <Route path="/courses/jee-main" element={<JEEMain />} />
            <Route path="/courses/jee-main/test" element={<JEEMainTest />} />
            <Route path="/courses/jee-main/analysis" element={<JEEMainAnalysis />} />
            <Route path="/courses/jee-main/quiz/:subject" element={<JEEMainQuiz />} />
            <Route path="/admin/jee-main" element={<JEEMainDashboard />} />

            {/* SAT — module-based quizzes */}
            <Route path="/courses/sat" element={<SATMain />} />
            <Route path="/courses/sat/modules" element={<SAT />} />
            <Route path="/courses/sat/quiz/:section/:module" element={<SATQuiz />} />
            <Route path="/courses/sat/full-test" element={<SATFullTest />} />
            <Route path="/courses/sat/analysis" element={<SATAnalysis />} />
            <Route path="/admin/sat" element={<SATDashboard />} />
            <Route path="/courses/sat/ScoreDashboard" element={<SATScoreDashboard />} />
            <Route path="/admin/sat/exam/:email/:subject/:attemptNumber" element={<SATExamAnalysis />} />

            {/* GRE — paper listing (like SAT) + module-based quizzes */}
            <Route path="/courses/gre" element={<GREMain />} />
            <Route path="/courses/gre/modules" element={<GRE />} />
            <Route path="/courses/gre/quiz/:section/:module" element={<GREQuiz />} />
            <Route path="/courses/gre/full-test" element={<GREFullTest />} />
            <Route path="/courses/gre/analysis" element={<GREAnalysis />} />
            <Route path="/admin/gre" element={<GREDashboard />} />
            <Route path="/courses/gre/ScoreDashboard" element={<GREScoreDashboard />} />
            <Route path="/admin/gre/exam/:email/:subject/:attemptNumber" element={<GREExamAnalysis />} />

                 
           {/* GMAT — paper listing (like GRE) + section-based quizzes */}
            <Route path="/courses/gmat" element={<GMATMain />} />
            <Route path="/courses/gmat/modules" element={<GMAT />} />
            <Route path="/courses/gmat/quiz/:section/:module" element={<GMATQuiz />} />
            <Route path="/courses/gmat/full-test" element={<GMATFullTest />} />
            <Route path="/courses/gmat/analysis" element={<GMATAnalysis />} />
            <Route path="/admin/gmat" element={<GMATDashboard />} />
            <Route path="/courses/gmat/ScoreDashboard" element={<GMATScoreDashboard />} />
            <Route path="/admin/gmat/exam/:email/:subject/:attemptNumber" element={<GMATExamAnalysis />} />


                 
            {/* ACT — paper listing (like GMAT) + section-based quizzes */}
            <Route path="/courses/act" element={<ACTMain />} />
            <Route path="/courses/act/modules" element={<ACT />} />
            <Route path="/courses/act/quiz/:section/:module" element={<ACTQuiz />} />
            <Route path="/courses/act/full-test" element={<ACTFullTest />} />
            <Route path="/courses/act/analysis" element={<ACTAnalysis />} />
            <Route path="/admin/act" element={<ACTDashboard />} />
            <Route path="/courses/act/ScoreDashboard" element={<ACTScoreDashboard />} />
            <Route path="/admin/act/exam/:email/:subject/:attemptNumber" element={<ACTExamAnalysis />} />
     

                 
            {/* GATE DA — paper listing (like SAT) + module-based quizzes, with negative marking */}
            <Route path="/courses/gate-da" element={<GATEDAMain />} />
            <Route path="/courses/gate-da/modules" element={<GATEDA />} />
            <Route path="/courses/gate-da/quiz/:section/:module" element={<GATEDAQuiz />} />
            <Route path="/courses/gate-da/full-test" element={<GATEDAFullTest />} />
            <Route path="/courses/gate-da/analysis" element={<GATEDAAnalysis />} />
            <Route path="/admin/gate-da" element={<GATEDADashboard />} />
            <Route path="/courses/gate-da/ScoreDashboard" element={<GATEDAScoreDashboard />} />
            <Route path="/admin/gate-da/exam/:email/:subject/:attemptNumber" element={<GATEDAExamAnalysis />} />

                 
           {/* CAT — paper listing (like GRE) + real 3-section (VARC/DILR/QA) structure, real negative marking */}
            <Route path="/courses/cat" element={<CATMain />} />
            <Route path="/courses/cat/modules" element={<CAT />} />
            <Route path="/courses/cat/quiz/:section/:module" element={<CATQuiz />} />
            <Route path="/courses/cat/full-test" element={<CATFullTest />} />
            <Route path="/courses/cat/analysis" element={<CATAnalysis />} />
            <Route path="/admin/cat" element={<CATDashboard />} />
            <Route path="/courses/cat/ScoreDashboard" element={<CATScoreDashboard />} />
            <Route path="/admin/cat/exam/:email/:subject/:attemptNumber" element={<CATExamAnalysis />} />    
                               




            {/* DBMS COURSE */}
            <Route path="/courses/DBMS" element={<DBMS />} />
            <Route path="/courses/DBMS/:weekId" element={<DBMSQuiz />} />

            {/* programming COURSE */}
            <Route path="/admin/pdsa" element={<PDSADashboard />} />
            <Route path="/admin/programming" element={<ProgrammingDashboard />} />
            <Route path="/admin/data-science" element={<DataScienceDashboard />} />
            <Route path="/programming/courses" element={<ProgrammingCourses />} />
            <Route path="/programming/courses/:course" element={<CoursePage />} />
            <Route path="/quiz/:course/week/:week" element={<QuizPage />} />
            <Route path="/coding/:course/week/:week" element={<CodingPage />} />
            <Route path="/programming/exams" element={<ExamPage />} />
            <Route path="/quiz/:course/exam" element={<QuizPage />} />

            {/* Software Testing — proctored Layer 1 diagnostic */}
            <Route path={ST_DIAGNOSTIC_PATH} element={<StDiagnostic />} />
            <Route path="/admin/software-testing/live" element={<StProctorView />} />
            <Route path="/admin/software-testing" element={<StAdmin />} />
            <Route path="/practice/writing-programs" element={<StPractice />} />
            <Route path="/practice/writing-programs/:problemId" element={<StPracticeProblem />} />

                 
          </Routes>
        </main>
        <SiteFooter />
      </div>
    </Router>
  )
}

export default App
